/* Administração do Portal do Exame de Textos de Idiomas */

export const pt = {
	/* Itens do Menu */

	'menu.serviceagreement': 'Acordo de Atendimento',
	'menu.statusServiceAgreementGreen': 'Status do acordo: Em dia',
	'menu.statusServiceAgreementRed': 'Status do acordo: Vencido',
	'menu.statusServiceAgreementYellow': 'Status do acordo: Atrasado',
	'menu.certification': 'Certificação Digital Pendente',
	'menu.newReport': 'Novo Laudo Manual',
	'menu.discardMaterial': 'Descarte de Material',
	'menu.messages': 'Mensagens',
	'menu.start': 'Início',
	'menu.retreat': 'Recolhimento',
	'menu.graphics': 'Gráficos',
	'menu.histology': 'Histologia',
	'menu.generalCytology': 'Citologia geral',
	'menu.immunology': 'Imunologia - Lâminas',
	'menu.taskControl': 'Controle de Tarefas',
	'menu.doctorTasks': 'Tarefas do médico',
	'menu.materialDisposal': 'Descarte de material',
	'menu.archivingRequisitionMaterials':
		'Arquivamento e Requisição de materiais',
	'menu.reports': 'Relatórios',
	'menu.requestsPanel': 'Painel de Solicitações',
	'menu.version': 'Versão',
	'menu.integratesoul': 'Integração Soul',

	/* Links */
	'link.integratesoul.cas': 'Soul',
	'link.integratesoul.insurance': 'Faturamento Convenio',
	'link.integratesoul.sus': 'Faturamento Sus',
	'link.integratesoul.pep': 'Pep',
	'link.integratesoul.psdi': 'Psdi',

	/* Protocol */
	'protocol.ventana': 'Integração Ventana',
	'protocol.date': 'Data',
	'protocol.doctor': 'Médico',
	'protocol.case': 'Caso',
	'protocol.protocol': 'Protocolo',
	'protocol.blade': 'Lâmina',
	'protocol.sent': 'Enviada',
	'protocol.recognized': 'Reconhecida',
	'protocol.chanting': 'Corando',
	'protocol.flushed': 'Corada',
	'protocol.finished': 'Finalizada',

	/* Tela de Login */

	'general.title': 'Anatomia Patológica',
	'general.title-min': 'Anatomía',
	'general.copyright': 'MV Sistemas © 2024 Todos os direitos reservados',
	'general.user': 'Usuário',
	'general.password': 'Senha',
	'general.incorrectPassword': 'Senha incorreta. Tente novamente.',
	'general.incorrectUser': 'Usuário incorreto. Tente novamente.',
	'general.accessAccount': 'Use sua conta para acessar o ',
	'general.logIn': 'Entrar',
	'general.forgotPassword': 'Esqueceu a senha?',
	'general.version': 'Versão:',
	'general.about': 'Sobre',
	'general.help': 'Ajuda',
	'general.login.next': 'Próximo',
	'general.login.back': 'Voltar',
	'general.login.wellcome': 'Bem-vindo',
	'general.login.email': 'E-mail',
	'general.login.text': 'Use sua conta para acessar o ',
	'general.login.mail.recovery':
		'Digite seu email que enviaremos um link para modificação da senha',
	'general.login.newaccount': 'Nova Conta',
	'general.login.select.company': 'Selecione uma Empresa',
	'general.protocol.ventana': 'Integração Ventana',
	'general.login.lowercasePasswordLabel': 'Pelo menos uma letra minúscula',
	'general.login.uppercasePasswordLabel': 'Pelo menos uma letra maiúscula',
	'general.login.numberPasswordLabel': 'Pelo menos um número',
	'general.login.caracterPasswordLabel': 'Pelo menos um caracter',
	'general.login.lenghtEightPasswordLabel': 'Pelo menos 8 caracteres',
	'general.login.placeholdPasswordConfirm': 'Confirmar Senha',
	'general.login.passwordMustBeEqual': 'As senhas devem ser iguais',

	/* 01.Inicio, Filtros, Pesquisa e Resultado */

	'dashboards.general.pt': 'Português (Brasil)',
	'dashboards.general.en': 'Inglês (Internacional)',
	'dashboards.general.es': 'Espanhol',
	'dashboards.general.logout': 'Sair',
	'dashboards.general.settings': 'Configurações',
	'dashboards.general.patientBusinessName': 'Paciente (Nome Social)',
	'dashboards.general.medicalRecord': 'Prontuário',
	'dashboards.general.examNumber': 'N° Exame',
	'dashboards.general.attendance': 'Atendimento',
	'dashboards.general.search': 'Buscar',
	'dashboards.general.currentFilter': 'Salvar filtro atual',
	'dashboards.general.recordsFound': 'Registros encontrados',
	'dashboards.general.orderBy': 'Ordenar por:',
	'dashboards.general.ascendingOrder': 'Ordenação Crescente',
	'dashboards.general.descendingOrder': 'Ordenação Decrescente',
	'dashboards.general.filterBy': 'Filtrar por:',
	'dashboards.general.approvalEnvironment': 'AMBIENTE DE HOMOLOGAÇÃO',
	'dashboards.general.clearFilters': 'Limpar filtros',
	'dashboards.general.noFilteredItems': 'Nenhum item filtrado',
	'dashboards.general.knowledgeBase': 'Base de Conhecimento',
	'dashboards.general.title': 'Anatomia Patológica',
	'dashboards.general.orderNumber': 'Número pedido',
	'dashboards.general.expectedDeliveryDate': 'Data Prevista Entrega',
	'dashboards.general.expectedDelivery': 'Data Prevista de Entrega',
	'dashboards.general.requestDate': 'Data do Pedido',
	'dashboards.general.deliveryDate': 'Data de Entrega',
	'dashboards.general.urgent': 'Urgentes',
	'dashboards.general.immunohistochemistryTests':
		'Exames de imuno-histoquímica',
	'dashboards.general.socialName': 'Nome Social',
	'dashboards.general.accessionNumber': 'Número de acesso',
	'dashboards.general.attendance': 'Atendimento',
	'dashboards.general.active': 'Ativo',
	'dashboards.general.SUSnationalCard': 'Cartão nacional SUS',
	'dashboards.general.healthInsurance': 'Convênio',
	'dashboards.general.deliveryDate': 'Data de entrega',
	'dashboards.general.releaseDate': 'Data de liberação',
	'dashboards.general.datenonCompliance': 'Data de não conformidade',
	'dashboards.general.requestDate': 'Data de solicitação',
	'dashboards.general.diagnosis': 'Diagnóstico',
	'dashboards.general.forwarding': 'Encaminhamento',
	'dashboards.general.exams': 'Exames',
	'dashboards.general.examGroup': 'Grupo exame',
	'dashboards.general.report': 'Laudo',
	'dashboards.general.sameEnrollment': 'Matrícula SAME',
	'dashboards.general.performingPhysician': 'Médico executante',
	'dashboards.general.medicalReviewer': 'Médico revisor',
	'dashboards.general.requestingDoctor': 'Médico solicitante',
	'dashboards.general.certifyingDoctor': 'Médico Certificador',
	'dashboards.general.nonCompliance': 'Não conformidade',
	'dashboards.general.externalExamNo': 'Nº Exame Externo',
	'dashboards.general.examNumber': 'Número exame',
	'dashboards.general.orderNumber': 'Número pedido',
	'dashboards.general.observationReport': 'Observação do Laudo', // MIrela alterar
	'dashboards.general.pacient': 'Paciente',
	'dashboards.general.procedure': 'Procedimento',
	'dashboards.general.medicalRecord': 'Prontuário',
	'dashboards.general.nonconformityResolution': 'Resolução não conformidade',
	'dashboards.general.requestingSector': 'Setor solicitante',
	'dashboards.general.stepStatus': 'Status da etapa',
	'dashboards.general.examType': 'Tipo exame',
	'dashboards.general.nonconformityType': 'Tipo não conformidade',
	'dashboards.general.topography': 'Topografia',
	'dashboards.general.serviceUnit': 'Unidade atendimento',
	'dashboards.general.urgent': 'Urgente',
	'dashboards.general.consultationGreater6Months':
		'Período consultado superior a 6 meses',
	'dashboards.general.consultationGreater1Year':
		'Período de consulta superior a 1 ano',
	'dashboards.general.enterValidEndDate':
		'Por favor, informe uma data final válida!',
	'dashboards.general.sampleReceipt': 'Recebimento de Amostra',
	'dashboards.general.email': 'Envio de Email',
	'dashboards.general.certification': 'Certificação Digital',
	'dashboards.general.certificationTab': 'Certificação',
	'dashboards.general.personalizedExam':
		'Desejo gerar o número do exame personalizado',
	'dashboards.general.initials': 'Sigla:',
	'dashboards.general.selectInitials': 'Selecione a posição da sigla',
	'dashboards.general.sequence': 'Sequência:',
	'dashboards.general.selectSequence': 'Selecione a posição da sequência',
	'dashboards.general.currentYear': 'Ano vigente:',
	'dashboards.general.selectCurrentYear': 'Selecione a posição do ano',
	'dashboards.general.separator': 'Separador:',
	'dashboards.general.selectSeparator': 'Selecione a posição do separador',
	'dashboards.general.exampleNumber':
		'O número do exame ficará conforme o exemplo:',
	'dashboards.general.resultExam':
		'Imprimir protocolo na entrega do resultado do exame',
	'dashboards.general.printStep': 'Imprimir laudo agrupado por etapa',
	'dashboards.general.stepNameNotes':
		'Informe o nome que deseja para etapa de Notas',
	'dashboards.general.addendum': 'Adendo',
	'dashboards.general.firstPosition': 'Primeira posição',
	'dashboards.general.secondPosition': 'Segunda posição',
	'dashboards.general.thirdPosition': 'Terceira posição',
	'dashboards.general.fourthPosition': 'Quarta posição',
	'dashboards.general.onCheckList':
		'Habilitar checklist para o recebimento de material',
	'dashboards.general.printLabel':
		'Imprimir etiqueta após finalizar o recebimento',
	'dashboards.general.pickupScreen':
		'Abrir tela de recolhimento de amostra após a finalização do recebimento',
	'dashboards.general.standardDoctorBill':
		'Sempre faturar usando o médico executante padrão',
	'dashboards.general.emailSender': 'Remetente (E-mail):',
	'dashboards.general.password': 'Senha:',
	'dashboards.general.smtp': 'SMTP:',
	'dashboards.general.door': 'Porta:',
	'dashboards.general.enabledigitalCertification':
		'Habilitar Certificação Digital',
	'dashboards.general.HSM': 'Utilizar HSM',
	'dashboards.general.urldigitalRegistry': 'Url do Cartório Digital:',
	'dashboards.general.shippingType': 'Tipo de Envio:',
	'dashboards.general.digitalNotaryVersion': 'Versão do Cartório Digital:',
	'dashboards.general.addFilters': 'Adicionar outros filtros',
	'dashboards.general.noFilter': 'Sem filtros disponíveis',
	'dashboards.general.favoriteFilter': 'Filtros favoritos',
	'dashboards.general.noFilterCreated': 'Nenhum favorito foi criado ainda',
	'dashboards.general.savedFilter': 'Salvar filtro atual como favorito',
	'dashboards.general.filterTitle': 'Informe um título para o filtro favorito',
	'dashboards.general.patternDoctor': 'Médico padrão:',
	'dashboards.general.maximumNumberBlades':
		'Número máximo de lâminas para leitura:',
	'dashboards.general.enableContinuousGeneration':
		'Habilitar geração contínua da numeração dos Cassetes',
	'dashboards.general.resultSearch': 'Resultado da Pesquisa',
	'dashboards.general.toView': 'Visualizar',
	'dashboards.general.fillField': 'Preencha este campo',
	'dashboards.general.occurrencesReports': 'Ocorrências Laudos:',
	'dashboards.general.today': 'Hoje',
	'dashboards.general.yesterday': 'Ontem',
	'dashboards.general.beforeYesterday': 'Antes de ontem',
	'dashboards.general.oneWeekAgo': 'Há 1 semana',
	'dashboards.general.week': 'Semana',
	'dashboards.general.month': 'Mês',
	'dashboards.general.fifteenDaysAgo': 'Há 15 dias',
	'dashboards.general.aMonthAgo': 'Há 1 mes',
	'dashboards.general.twoMonthsAgo': 'Há 2 meses',
	'dashboards.general.threeMonthsAgo': 'Há 3 meses',
	'dashboards.general.sixMonthsAgo': 'Há 6 meses',
	'dashboards.general.aYearAgo': 'Há 1 ano',
	'dashboards.general.other': 'Outro',
	'dashboards.general.selectPeriod': 'Selecione um período',
	'dashboards.general.startDateGreaterEndDate': 'A data inicial é maior que a data final',
	'dashboards.general.informValidStartDate': 'Informe uma data inicial válida',
	'dashboards.general.informValidEndDate': 'Informe uma data final válida',
	'dashboards.general.CPF': 'CPF',
	'dashboards.general.birthDate': 'Data de nascimento',

	/* 02.Detalhes do Exame, Laudo  e Editor */

	'dashboards.examDetails.linkExams': 'Vincular exames:',
	'dashboards.examDetails.socialName': 'Nome Social: ',
	'dashboards.examDetails.exam': 'Exame: ',
	'dashboards.examDetails.numberExam': 'Número exame: ',
	'dashboards.examDetails.birthDate': 'Data Nasc: ',
	'dashboards.examDetails.sex': 'Sexo: ',
	'dashboards.examDetails.previousExamNumber': 'Nº exame anterior: ',
	'dashboards.examDetails.completionDate': 'Data Conclusão ',
	'dashboards.examDetails.orderDate': 'Data Pedido: ',
	'dashboards.examDetails.request': 'Pedido: ',
	'dashboards.examDetails.attendance': 'Atendimento: ',
	'dashboards.examDetails.attendanceType': 'Tipo de atendimento',
	'dashboards.examDetails.attendanceDate': 'Data do atendimento',
	'dashboards.examDetails.healthInsurance': 'Convênio: ',
	'dashboards.examDetails.canceled': 'Cancelados ',
	'dashboards.examDetails.messages': 'Mensagens ',
	'dashboards.examDetails.block': 'Qtd Bloco: ',
	'dashboards.examDetails.blade': 'Qtd Lâmina: ',
	'dashboards.examDetails.externalExam': 'Nº Exame Externo: ',
	'dashboards.examDetails.urgent': 'Urgente',
	'dashboards.examDetails.criticalReport': 'Laudo crítico',
	'dashboards.examDetails.changeOfUrgency':
		'Confirmar a alteração da urgência desse laudo?',
	'dashboards.examDetails.changeInCriticality':
		'Confirmar a alteração da criticidade desse laudo?',
	'dashboards.examDetails.justification': 'Justificativa:',
	'dashboards.examDetails.cancel': 'Cancelar',
	'dashboards.examDetails.confirm': 'Confirmar',
	'dashboards.examDetails.patientCriticalReport':
		'Paciente com histórico de laudo crítico',
	'dashboards.examDetails.requestingDoctor': 'Médico Solic.:',
	'dashboards.examDetails.examRequest': 'Pedido de Exame:',
	'dashboards.examDetails.expectedDeliveryDate': 'Data Entrega Prevista',
	'dashboards.examDetails.released': 'LIBERADO',
	'dashboards.examDetails.autoText': 'Auto texto',
	'dashboards.examDetails.attachments': 'Anexos',
	'dashboards.examDetails.previousReports': 'Laudos anteriores',
	'dashboards.examDetails.reportHistory': 'Histórico laudo',
	'dashboards.examDetails.bladeList': 'Lista de Lâminas',
	'dashboards.examDetails.status.nonCompliance': 'Não conformidade',
	'dashboards.examDetails.status.nochecked': 'Não realizada',
	'dashboards.examDetails.status.pending': ' Pendente',
	'dashboards.examDetails.status.checked': ' Realizada',
	'dashboards.examDetails.status.revision': ' Revisão',
	'dashboards.examDetails.status.notApplicable': ' Não aplicável',
	'dashboards.examDetails.status.lecturer': 'Conferencista',
	'dashboards.examDetails.step.material': 'MATERIAL',
	'dashboards.examDetails.step.macro': 'MACRO',
	'dashboards.examDetails.step.micro': 'MICRO',
	'dashboards.examDetails.step.imuno': 'IMUNO',
	'dashboards.examDetails.step.histo': 'HISTO',
	'dashboards.examDetails.step.cish': 'CISH',
	'dashboards.examDetails.step.fish': 'FISH',
	'dashboards.examDetails.step.pcr': 'PCR',
	'dashboards.examDetails.step.congelacao': 'CONGELAÇÃO',
	'dashboards.examDetails.step.conclusao': 'CONCLUSÃO',
	'dashboards.examDetails.step.errata': 'ERRATA/INFORMAÇÕES ADICIONAIS',
	'dashboards.examDetails.cid': 'CID',
	'dashboards.examDetails.traceability': 'Rastreabilidade',
	'dashboards.examDetails.invoicing': 'Faturamento',
	'dashboards.examDetails.resultDelivery': 'Entrega de resultado de exame',
	'dashboards.examDetails.printStep': 'Imprimir Etapa',
	'dashboards.examDetails.printLabels': 'Imprimir Etiquetas',
	'dashboards.examDetails.includeRemarks': 'Incluir observações',
	'dashboards.examDetails.protocolRequirements': 'Requisitos de protocolos',
	'dashboards.examDetails.freezingRequest': 'Requisição de congelação',
	'dashboards.examDetails.releaseReport': 'Liberar Laudo',
	'dashboards.examDetails.blockBladeControl': 'Controle de Blocos e Lâminas',
	'dashboards.examDetails.sendEmail': 'Enviar Email',
	'dashboards.examDetails.reopenSteps': 'Reabrir Etapas',
	'dashboards.examDetails.openExams': 'Exames em aberto',
	'dashboards.examDetails.examLinked': 'Exame com laudo vinculado',
	'dashboards.examDetails.nextDeliveryDate': 'Data de entrega próxima',
	'dashboards.examDetails.criticalReport': 'Laudo crítico',
	'dashboards.examDetails.urgentExam': 'Exame urgente',
	'dashboards.examDetails.printedTermofConsent': 'Termo de Anuência impresso',
	'dashboards.examDetails.examDeliveredIn': 'Exame Entregue em: ',
	'dashboards.examDetails.billExams': 'Faturar exames',
	'dashboards.examDetails.multipleExams': 'Múltiplos exames',
	'dashboards.examDetails.quantity': 'Quantidade:',
	'dashboards.examDetails.examStage': 'Etapa do exame:',
	'dashboards.examDetails.invoice': 'Faturar',
	'dashboards.examDetails.manualDisabled': '* Faturamento manual desabilitado',
	'dashboards.examDetails.unbilledItems':
		'Há itens não faturados, deseja fechar assim mesmo?',
	'dashboards.examDetails.yes': 'Sim',
	'dashboards.examDetails.no': 'Não',
	'dashboards.examDetails.na': 'Não se aplica',
	'dashboards.examDetails.changeswillbelost':
		'Ao fechar todas as alterações serão perdidas!',
	'dashboards.examDetails.applicablesteps':
		'* Não há etapas com faturamento aplicável para este exame',
	'dashboards.examDetails.selectStage': 'Selecionar a etapa do exame',
	'dashboards.examDetails.stageDoctor': 'Médico da etapa:',
	'dashboards.examDetails.selectDoctorStage': 'Selecionar o médico dessa etapa',
	'dashboards.examDetails.new': 'Novo',
	'dashboards.examDetails.changed': 'Alterado',
	'dashboards.examDetail.doctorUndefined':
		'Médico executante da etapa indefinido!',
	'dashboards.examDetail.billed': 'Faturado',
	'dashboards.examDetail.pendingBilling': 'Faturamento Pendente',
	'dashboards.examDetail.thereWasProblem': 'Ocorreu um problema',
	'dashboards.examDetail.addExam': 'Adicionar novo exame',
	'dashboards.examDetail.viewadditionalinfo': 'Ver informações adicionais',
	'dashboards.examDetail.selectExam': 'Selecionar exame',
	'dashboards.examDetail.exams': 'Exames:',
	'dashboards.examDetail.multiploExams': 'Múltiplos exames:',
	'dashboards.examDetail.performingPhysician': 'Médico executante:',
	'dashboards.examDetail.selectDoctor': 'Selecionar médico solicitante',
	'dashboards.examDetail.annotationsExam': 'Anotações sobre o exame:',
	'dashboards.examDetail.save': 'Gravar',
	'dashboards.examDetail.edit': 'Editar',
	'dashboards.examDetail.delete': 'Apagar',
	'dashboards.examDetail.billExam': 'Faturar exame',
	'dashboards.examDetail.cancelBilling': 'Cancelar faturamento',
	'dashboards.examDetail.generate': 'Gerar',
	'dashboards.examDetail.generateImpression': 'Gerar impressão',
	'dashboards.examDetail.printLabels': 'Imprimir etiquetas:',
	'dashboards.examDetail.selectAll': 'Selecionar todas',
	'dashboards.examDetail.bottle': 'Frasco: ',
	'dashboards.examDetail.controlLabel': 'Etiqueta de controle',
	'dashboards.examDetail.label': 'Etiquetas',
	'dashboards.examDetail.comments': 'Observações',
	'dashboards.examDetail.reportObservation': 'Informe aqui a sua observação',
	'dashboards.examDetail.patient': 'Paciente:',
	'dashboards.examDetail.date': 'Data:',
	'dashboards.examDetail.numberOfExam': 'Número do exame:',
	'dashboards.examDetail.topography': 'Topografia:',
	'dashboards.examDetail.selectTopography': 'Selecionar topografia',
	'dashboards.examDetail.CID': 'CID:',
	'dashboards.examDetail.enter': 'Insira ao menos',
	'dashboards.examDetail.searchCharacters': 'caracteres na pesquisa',
	'dashboards.examDetail.selectCID': 'Selecione o CID',
	'dashboards.examDetail.mainDiagnosis': 'Diagnóstico Principal (CID-O)',
	'dashboards.examDetail.annotations': 'Anotações:',
	'dashboards.examDetail.generalObservations': 'Observações gerais',
	'dashboards.examDetail.adding': 'Adicionar',
	'dashboards.examDetail.close': 'Fechar',
	'dashboards.examDetail.cidTopography': 'CID/Topografias',
	'dashboards.examDetail.annotation': 'Anotação:',
	'dashboards.examDetail.toSave': 'Salvar',
	'dashboards.examDetail.mandatoryCID':
		'Obrigatório cadastrar CID para o laudo',
	'dashboards.examDetail.operation': 'Operação:',
	'dashboards.examDetail.sectorChange': 'Mudança de setor',
	'dashboards.examDetail.user': 'Usuário:',
	'dashboards.examDetail.action': 'Ação:',
	'dashboards.examDetail.userJustification': 'Justificativa do usuário:',
	'dashboards.examDetail.requisitionFreezingReport':
		'Requisição de congelação laudo',
	'dashboards.examDetail.freezingBlock': 'Bloco da Congelação:',
	'dashboards.examDetail.selectFreezingBlock':
		'Selecionar um bloco da congelação (opcional)',
	'dashboards.examDetail.noFreezeBlock':
		'Nenhum bloco da congelação para este exame',
	'dashboards.examDetail.addBlock': '+ Bloco',
	'dashboards.examDetail.bladeAddOn': 'Complemento lâmina',
	'dashboards.examDetail.selectBladeAddOn': 'Selecionar complemento da lâmina',
	'dashboards.examDetail.registerNewAddOn': 'Cadastrar novo complemento',
	'dashboards.examDetail.unconformities': 'Não conformidades:',
	'dashboards.examDetail.selectUnconformities': 'Selecionar não conformidade',
	'dashboards.examDetail.freezingTechnician': 'Técnico da Congelação:',
	'dashboards.examDetail.selectTechnician': 'Selecionar técnico',
	'dashboards.examDetail.freezingPathologist': 'Patologista da Congelação:',
	'dashboards.examDetail.selectPathologist': 'Selecionar patologista',
	'dashboards.examDetail.clearFields': 'Limpar campos',
	'dashboards.examDetail.listBlades': 'Listar Lâminas',
	'dashboards.examDetail.requester': 'Solicitante',
	'dashboards.examDetail.block': 'Bloco',
	'dashboards.examDetail.blade': 'Lâmina',
	'dashboards.examDetail.performSearch': 'Digite algo para a busca',
	'dashboards.examDetail.noRecordFound': 'Nenhum registro encontrado',
	'dashboards.examDetail.qtyBlades': 'Qtd. lâminas',
	'dashboards.examDetail.addBlade': 'Adicionar lâmina',
	'dashboards.examDetail.macroscopicMap': 'Mapa macroscópico',
	'dashboards.examDetail.technicalArea': 'Área técnica',
	'dashboards.examDetail.generalCytology': 'Citologia geral',
	'dashboards.examDetail.freezing': 'Congelação',
	'dashboards.examDetail.blockandBladeControl': 'Controle de Blocos e Lâminas',
	'dashboards.examDetail.table.blade': 'Lâmina',
	'dashboards.examDetail.table.delegateTechnician': 'Técnico delegado',
	'dashboards.examDetail.table.exam': 'Exame',
	'dashboards.examDetail.table.status': 'Status',
	'dashboards.examDetail.table.registrationDate': 'Data de cadastro',
	'dashboards.examDetail.table.noResultsFound': 'Nenhum resultado encontrado',
	'dashboards.examDetail.table.coloring': 'Coloração',
	'dashboards.examDetail.table.technician': 'Técnico',
	'dashboards.examDetail.table.pathologist': 'Patologista',
	'dashboards.examDetail.table.complement': 'Complemento',
	'dashboards.examDetail.table.editComplement': 'Edição de Complementos',
	'dashboards.examDetail.cancelStep.confirm': 'Confirme a reabertura das etapas',
	'dashboards.examDetail.cancelStep.confirmCancel':'Ao confirmar, as etapas abaixo serão reabertas',
	'dashboards.examDetail.cancelStep.select': 'Selecione a etapa',
	'dashboards.examDetail.cancelStep.selectStep': '- Selecione uma etapa',
	'dashboards.examDetail.cancelStep.legends': 'Legendas:',
	'dashboards.examDetail.cancelStep.stepsCompleted':
		'Etapas que permanecerão concluídas',
	'dashboards.examDetail.cancelStep.stepsCanceled': 'Etapas que serão reabertas',
	'dashboards.examDetail.cancelStep.stepsNotAllowed': 'Etapas não permitidas execução de reabertura pelo usuário',
	'dashboards.examDetail.cancelStep.stepCancel': 'Reabrir etapa(s)',
	'dashboards.examDetail.sendReportEmail': 'Enviar laudo por Email -',
	'dashboards.examDetail.recipient': 'Destinatário',
	'dashboards.examDetail.recipientEmail': 'Informe o Email de destinatário',
	'dashboards.examDetail.subject': 'Assunto',
	'dashboards.examDetail.subjectEmail': 'Informe o assunto do Email',
	'dashboards.examDetail.enterText': 'Informe um texto...',
	'dashboards.examDetail.protocolRequestAvailable':
		'Requisição de Protocolo Disponível',
	'dashboards.examDetail.protocolRequirements':
		'Requisitos de protocolos do laudo',
	'dashboards.examDetail.antibodyInformed':
		'Anticorpo já informado. Deseja lançar novamente?',
	'dashboards.examDetail.errataInformed':
		'Deseja lançar a Errata para o laudo já concluído e/ou liberado?',
	'dashboards.examDetail.blocky': 'Bloco:',
	'dashboards.examDetail.numberOfExame': 'Nº exame:',
	'dashboards.examDetail.Material': 'Material',
	'dashboards.examDetail.doctorRequesting': 'Médico solicitante:',
	'dashboards.examDetail.typeAntibody': 'Tipo de Anticorpos:',
	'dashboards.examDetail.typeSelect': 'Selecionar tipo',
	'dashboards.examDetail.destiny': 'Destino:',
	'dashboards.examDetail.antibodies': 'Anticorpos:',
	'dashboards.examDetail.selectReagent': 'Selecionar o reagente',
	'dashboards.examDetail.addAntibodies': 'Adicionar anticorpos',
	'dashboards.examDetail.antigen': 'Antígeno',
	'dashboards.examDetail.delete': 'Excluir',
	'dashboards.examDetail.selectCase': 'Selecionar caso (bloco)',
	'dashboards.examDetail.favorites': 'Favoritos',
	'dashboards.examDetail.saveFavorite': 'Salvar Favorito',
	'dashboards.examDetail.saveFilter': ' Salvar filtro',
	'dashboards.examDetail.favoriteName': 'Nome do favorito:',
	'dashboards.examDetail.stepCancellation': 'Reabertura de etapa',
	'dashboards.examDetail.justificationCancellation': 'Justificativa de reabertura',
	'dashboards.examDetail.justificationForCancellation': 'Justificativa para o cancelamento',
	'dashboards.examDetail.justificationForReopening': 'Justificativa para a reabertura',
	'dashboards.examDetail.comeBack': 'Voltar',
	'dashboards.examDetail.cancelStep': 'Reabrir etapa',
	'dashboards.examDetail.cancellation': 'Cancelamento:',
	'dashboards.examDetail.cancelingAllowed':
		'Não é permitido cancelar o recebimento de material de laudos com etapas realizadas',
	'dashboards.examDetail.confirmCancellation': 'Confirmar cancelamento',
	'dashboards.examDetail.deliveryCancellation': 'Cancelamento da entrega',
	'dashboards.examDetail.message.user': 'Mensagens - Usuário',
	'dashboards.examDetail.message.report': 'Mensagens - Laudo',
	'dashboards.examDetail.message.conversations': 'Conversas',
	'dashboards.examDetail.message.subject': 'Assunto:',
	'dashboards.examDetail.message.messageRecipient': 'Destinatário da mensagem',
	'dashboards.examDetail.message.submit': 'Enviar',
	'dashboards.examDetail.message.noConversationFound':
		'Nenhuma conversa encontrada',
	'dashboards.examDetail.message.conversationTopic': 'Assunto da Conversa:',
	'dashboards.examDetail.message.firstMessage': 'Primeira Mensagem:',
	'dashboards.examDetail.message.blockedMessages':
		'Envio de mensagens está bloqueado, pois este laudo já foi entregue!',
	'dashboards.examDetail.certificate': 'Certificado',
	'dashboards.examDetail.noCertificate': 'Não certificado',
	'dashboards.examDetail.linkPastExams': 'Vincular exames anteriores ao laudo',
	'dashboards.examDetail.CIDReport': 'CID do laudo',
	'dashboards.examDetail.wasNotTyped':
		'Não foi digitado o laudo para o exame. Insira um texto no laudo para incluir o CID',
	'dashboards.examDetail.wasNotTypedMorphology':
		'Não foi digitado o laudo para o exame. Insira um texto no laudo para realizar a Morfologia',
	'dashboards.examDetail.notTyped':
		'Não foi digitado o laudo para o exame. Este laudo só poderá ser gravado como pendente. Verifique!',
	'dashboards.examDetail.newExam':
		'O novo exame usará o mesmo material do exame vinculado',
	'dashboards.examDetail.link': 'Vincular',
	'dashboards.examDetail.noLink': 'Desvincular',
	'dashboards.examDetail.linkReport': 'Vincular ao laudo',
	'dashboards.examDetail.noLinkReport': 'Desvincular do laudo',
	'dashboards.examDetail.justification': 'Justificativa',
	'dashboards.examDetail.informCID': 'É necessário informar o CID',
	'dashboards.examDetail.setCID': 'Por favor defina um CID principal',
	'dashboards.examDetail.reportConclusionExam': 'Laudo de Conclusão do Exame',
	'dashboards.examDetail.reportAndConclusion': 'Laudar e Concluir',
	'dashboards.examDetail.requisitionReportProtocols':
		'Requisição de protocolos do laudo',
	'dashboards.examDetail.sampleCollection': 'Recolhimento de amostra',
	'dashboards.examDetail.finalizeMaterialReceipt':
		'Finalizar Recebimento de Material',
	'dashboards.examDetail.toReceive': 'Receber',
	'dashboards.examDetail.externalExam': 'Exame Externo',
	'dashboards.examDetail.Unconformities': 'Não conformidades',
	'dashboards.examDetail.attachment': 'Anexo',
	'dashboards.examDetail.docExternal': 'Doc. Externos',
	'dashboards.examDetail.Cancellation': 'Cancelamento',
	'dashboards.examDetail.checklist': 'Checklist',
	'dashboards.examDetail.savePending': 'Salvar como pendente',
	'dashboards.examDetail.finalize': 'Finalizar',
	'dashboards.examDetail.nextStep': 'Próxima Etapa',
	'dashboards.examDetail.reopenStep': 'Reabrir Etapa',
	'dashboards.examDetail.reopenStepQuestion': 'Deseja reabrir a etapa?',
	'dashboards.examDetail.changeTopography': 'Alterar Topografia',
	'dashboards.examDetail.bottleCancellation': 'Cancelamento de Frasco',
	'dashboards.examDetail.lastBottle':
		'Este é o último frasco. Se for cancelado, o recebimento também será cancelado e o número do exame será perdido.',
	'dashboards.examDetail.reportTopography': 'Informe topografia',
	'dashboards.examDetail.registerNewTopography': 'Cadastrar nova topografia',
	'dashboards.examDetail.removedBottle': 'Frasco removido',
	'dashboards.examDetail.addBottles': 'Frasco(s) adicionado(s)',
	'dashboards.examDetail.materialReceipt': 'Recebimento material realizado',
	'dashboards.examDetail.deleteExternalDocument': 'Excluir Documento Externo',
	'dashboards.examDetail.receiptUsingExternalExam':
		'Recebimento utilizando exame externo',
	'dashboards.examDetail.externalExamNumber': 'Número do Exame Externo',
	'dashboards.examDetail.update': 'Atualizar',
	'dashboards.examDetail.deleteExternalExam': 'Excluir Exame Externo',
	'dashboards.examDetail.printIndividualTerm': 'Imprimir termo individual',
	'dashboards.examDetail.printer': 'Impressora',
	'dashboards.examDetail.selectPrinter':
		'Selecione uma impressora para emissão do termo',
	'dashboards.examDetail.printConsolidatedTerm': 'Imprimir termo consolidado',
	'dashboards.examDetail.addNonconformity': 'Adicionar Não Conformidade',
	'dashboards.examDetail.displayNoncompliance':
		'Exibir não conformidade no texto final do laudo',
	'dashboards.examDetail.confirmPrintConsolidated':
		'Confirmar e imprimir consolidado',
	'dashboards.examDetail.confirmClose': 'Confirmar e fechar',
	'dashboards.examDetail.printTerm': 'Imprimir termo',
	'dashboards.examDetail.noItems':
		'Não há itens cadastrados para o checklist de verificação',
	'dashboards.examDetail.receiptMaterialBlocked':
		'O recebimento do material foi bloqueado',
	'dashboards.examDetail.questionnaireSuccessfully':
		'Questionário respondido com sucesso',
	'dashboards.examDetail.openExam': 'Exames em aberto:',
	'dashboards.examDetail.solicted': 'Solicitado por ',
	'dashboards.examDetail.performedBy': ' Executado por',
	'dashboards.examDetail.executed': ' Executado',
	'dashboards.examDetail.step': ' Etapa',
	'dashboards.examDetail.pendingMacro': 'Macro pendente',
	'dashboards.examDetail.Attachment': 'Anexo:',
	'dashboards.examDetail.fileAttachment': 'Anexo de Arquivo',
	'dashboards.examDetail.deletearchive': 'Deseja excluir o arquivo',
	'dashboards.examDetail.selectarchive': 'Selecione o arquivo',
	'dashboards.examDetail.download': 'Download',
	'dashboards.examDetail.successAttached': 'Arquivo anexado com sucesso!',
	'dashboards.examDetail.attachmentFailure':
		'Não foi possível anexar o arquivo!',
	'dashboards.examDetail.attachmentError':
		'Este arquivo já está anexado ao exame!',
	'dashboards.examDetail.fileRemoved': 'Arquivo removido com sucesso',
	'dashboards.examDetail.documentDescription': 'Descrição do documento:',
	'dashboards.examDetail.receiveDocument': 'Receber documento',
	'dashboards.examDetail.deliveredIn': ' Entregue em',
	'dashboards.examDetail.receivedIn': 'Documento recebido em',
	'dashboards.examDetail.documentRegistered': 'Documento registrado!',
	'dashboards.examDetail.complementaryExamRemoved':
		'Exame complementar removido!',
	'dashboards.examDetail.additionalExamAdded': 'Exame complementar adicionado!',
	'dashboards.examDetail.updatedSupplementaryExam':
		'Exame complementar atualizado!',
	'dashboards.examDetail.failedEditExam': 'Falha ao editar exame',
	'dashboards.examDetail.questionnaireHistory': 'Histórico Questionario:',
	'dashboards.examDetail.replyAgain': 'Responder novamente',
	'dashboards.examDetail.impeditive': 'Impeditivo',
	'dashboards.examDetail.quiz': 'Questionário:',
	'dashboards.examDetail.finishReceivingMaterial':
		'Deseja finalizar o recebimento de material sem informar novos frascos?',
	'dashboards.examDetail.sampleOrigin': 'Local de origem da amostra',
	'dashboards.examDetail.receivedBy': 'Recebido por',
	'dashboards.examDetail.processFor': 'Processo para',
	'dashboards.examDetail.delegationTo': 'Delegação para',
	'dashboards.examDetail.receiptCompletedMaterial':
		'Recebimento de material concluido',
	'dashboards.examDetail.materialSavedPending': 'Material salvo como pendente',
	'dashboards.examDetail.errorExamExternal':
		'Ocorreu um erro no recebimento do exame externo',
	'dashboards.examDetail.bottleCanceled':
		'Frasco cancelado pela exclusão do exame externo associado',
	'dashboards.examDetail.receiptMaterialCanceled':
		'Recebimento de material cancelado com sucesso',
	'dashboards.examDetail.externalExamDeleted':
		'Número exame externo excluido com sucesso',
	'dashboards.examDetail.errorUpdateInformation':
		'Ocorreu um erro ao tentar atualizar as informações',
	'dashboards.examDetail.unableCancelSteps':
		'Não foi possível cancelar as etapas',
	'dashboards.examDetail.grouped': 'Agrupado',
	'dashboards.examDetail.general': 'Geral',
	'dashboards.examDetail.noAutoTextRegistered': 'Nenhum auto texto registrado',
	'dashboards.examDetail.shortcut': 'Atalho',
	'dashboards.examDetail.defaultText': 'Texto padrão',
	'dashboards.examDetail.noAttachmentsRegistered': 'Nenhum anexo registrado',
	'dashboards.examDetail.noClinicalReportExam':
		'Não há um informe clínico para este exame',
	'dashboards.examDetail.reportAddedReport':
		'Informe clínico adicionado no laudo',
	'dashboards.examDetail.insertMapReport': 'Inserir mapa macroscópico no laudo',
	'dashboards.examDetail.listBlocks': 'Lista de blocos',
	'dashboards.examDetail.noPreviousReportRegistered':
		'Nenhum laudo anterior registrado',
	'dashboards.examDetail.previousReport':
		'Laudo anterior',
	'dashboards.examDetail.noHistoryRecorded': 'Nenhum histórico registrado',
	'dashboards.examDetail.dateChange': 'Data da alteração:',
	'dashboards.examDetail.insertReport': 'Inserir no laudo',
	'dashboards.examDetail.noBlades': 'Não há lâminas listadas para essa etapa!',
	'dashboards.examDetail.multipleExams': 'Múltiplos Exames',
	'dashboards.examDetail.includeClinicalReports': 'Incluir informes clínicos',
	'dashboards.examDetail.crm': 'CRM',
	'dashboards.examDetail.reviewer': 'Revisor',
	'dashboards.examDetail.notesSelectText': 'NOTAS - Selecione o texto',
	'dashboards.examDetail.completeTheExam':
		'O Exame deve estar concluído para acessar esta etapa',
	'dashboards.examDetail.impedingNonCompliance':
		'Existe não conformidade impeditiva na área técnica',
	'dashboards.examDetail.fullyReleaseReport':
		'Deseja liberar totalmente o laudo?',
	'dashboards.examDetail.fullRelease': 'Liberação total do Laudo',
	'dashboards.examDetail.headsUp': 'Atenção!',
	'dashboards.examDetail.reportSave': 'Laudo salvo com sucesso',
	'dashboards.examDetail.notAllowed': 'Autorização não permitida',
	'dashboards.examDetail.onlyDoctors': 'Somente médicos podem laudar!',
	'dashboards.examDetail.reportNonCompliance':
		'Este laudo possui uma ou mais não conformidades',
	'dashboards.examDetail.previousExams':
		'Quantidade de exame(s) anterior(es) crítico(s)',
	'dashboards.examDetail.laud': 'Laudar',
	'dashboards.examDetail.laudPendent': 'Laudar pendente',
	'dashboards.examDetail.laudAndConclusion': 'Laudar e Concluir o Exame',
	'dashboards.examDetail.laudLecturer': 'Laudar conferencista',
	'dashboards.examDetail.cassettes': 'Cassetes',
	'dashboards.examDetails.errata': 'ERRATA/INFORMAÇÕES ADICIONAIS',
	'dashboards.examDetails.years': 'anos',
	'dashboards.examDetails.months': 'meses',
	'dashboards.examDetails.masculine': 'Masculino',
	'dashboards.examDetails.feminine': 'Feminino',
	'dashboards.examDetails.undefined': 'Indefinido',
	'dashboards.examDetails.examCassetteGeneration':
		'Geração de Cassete do exame',
	'dashboards.examDetails.fullySubmittedExam':
		'Material totalmente submetido ao exame',
	'dashboards.examDetails.selectBottle': 'Selecione o frasco',
	'dashboards.examDetails.antigens': 'Antígenos:',
	'dashboards.examDetails.selectMaterial': 'Selecione o material',
	'dashboards.examDetails.registerNewMaterial': 'Cadastrar novo material',
	'dashboards.examDetails.selectTechnician': 'Selecione o técnico',
	'dashboards.examDetails.selectDoctor': 'Selecione o médico',
	'dashboards.examDetails.typeDiscard': 'Tipo de descarte:',
	'dashboards.examDetails.selectTypeDisposal': 'Selecione o tipo de descarte',
	'dashboards.examDetails.doctorRequestingDisposal':
		'Médico solicitante do descarte:',
	'dashboards.examDetails.groupSelectedCassettes':
		'Agrupar cassetes selecionados',
	'dashboards.examDetails.canceled': 'Cancelado',
	'dashboards.examDetails.canceledCassettes': 'Cassetes cancelados',
	'dashboards.examDetails.laud': 'Laudo:',
	'dashboards.examDetails.medicalRecord': 'Prontuário:',
	'dashboards.examDetails.datePerformed': 'Data realizado:',
	'dashboards.examDetails.backToList': 'Voltar para lista',
	'dashboards.examDetails.enableEditing': 'Habilitar edição',
	'dashboards.examDetails.saveChange': 'Salvar alteração',
	'dashboards.examDetails.addCassete': 'Adicionar Cassete',
	'dashboards.examDetails.urgentUserExam':
		'Exame sinalizado como urgente no mapa macroscópico pelo usuário',
	'dashboards.examDetails.printReceptacleControl':
		'Imprimir controle de receptáculo',
	'dashboards.examDetails.finishMacroscopicMap': 'Finalizar Mapa Macroscópico',
	'dashboards.examDetails.reopenMacroscopicMap': 'Reabrir Mapa Macroscópico',
	'dashboards.examDetails.recorded': 'GRAVADO',
	'dashboards.examDetails.canceledBlock': 'Cancelar Bloco',
	'dashboards.examDetails.shippingDate': 'Data do Envio:',
	'dashboards.examDetails.certifySelection': 'Certificar Seleção',
	'dashboards.examDetails.certifyAll': 'Certificar Todos',
	'dashboards.examDetails.invalidCPF': 'CPF Inválido',
	'dashboards.examDetails.submitCertification': 'Enviar para certificação',
	'dashboards.examDetails.cpf': 'CPF:',
	'dashboards.examDetails.pin': 'PIN:',
	'dashboards.examDetails.certify': 'Certificar',
	'dashboards.examDetails.reports': 'Laudos:',
	'dashboards.examDetails.noncomplianceReport': 'Não conformidade do laudo',
	'dashboards.examDetails.reportLabels': 'Etiquetas do laudo',
	'dashboards.examDetails.openExamReport': 'Exames em aberto do laudo',
	'dashboards.examDetails.reportBaskets': 'Cestas do laudo',
	'dashboards.examDetails.reportProtocol': 'Protocolo do laudo',
	'dashboards.examDetails.saved':
		'Salvar alterações no texto do laudo antes de sair?',
	'dashboards.examDetails.saveEditions': 'Salvar alterações',
	'dashboards.examDetails.launchAddendumReport':
		'Deseja lançar o adendo para o laudo já concluído e/ou liberado',
	'dashboards.examDetails.doctorPerformingReport':
		'Informe o médico executante do laudo',
	'dashboards.examDetails.medicalReportReviewer':
		'Informe o médico revisor do laudo',
	'dashboards.examDetails.filterName': 'Nome do filtro:',
	'dashboards.examDetails.visibleGroupUsers': 'Visível para usuários do grupo:',
	'dashboards.examDetails.startupFilter':
		'Definir como filtro de inicialização',
	'dashboards.examDetails.materialReceipt': 'Recebimento Material',
	'dashboards.examDetails.macro': 'Macroscopia',
	'dashboards.examDetails.micro': 'Microscopia',
	'dashboards.examDetails.fish': 'Fish',
	'dashboards.examDetails.cish': 'Cish',
	'dashboards.examDetails.histo': 'Histo',
	'dashboards.examDetails.notes': 'Notas',
	'dashboards.examDetails.conclusion': 'Conclusão',
	'dashboards.examDetails.printed': 'Impresso',
	'dashboards.examDetails.term': 'Termo:',
	'dashboards.examDetails.unitys': 'Unidades:',
	'dashboards.examDetails.periods': 'Períodos:',
	'dashboards.examDetails.yearsOld': 'Idade:',
	'dashboards.examDetails.reset': 'Redefinir',
	'dashboards.examDetails.noPendingCertificates': 'Nenhum certificado pendente',
	'dashboards.examDetails.billingStatus': 'Status do Faturamento',
	'dashboards.examDetails.examStatus': 'Status do Exame',
	'dashboards.examDetails.PatientSSN': 'CPF do paciente',
	'dashboards.examDetails.reportDeliveredPortal': 'Laudo entregue: Portal de Exames',
	'dashboards.examDetails.imagesVivaceConnect': 'Imagens associadas ao exame disponíveis para visualização no Vivace Connect',
	'dashboards.examDetails.microscopist': 'Microscopista',
	'dashboards.examDetails.tagNew': '(NOVO)',
	'dashboards.examDetails.tagSaved': '(GRAVADO)',
	'dashboards.examDetails.tagCancelled': '(CANCELADO)',
	'dashboards.examDetails.externalExamFlask': 'Frasco derivado do exame externo',
	'dashboards.examDetails.errorDate': 'Data inválida',

	/* 03.Recolhimento de Amostra */

	'dashboards.sample.fillAllFormFields':
		'Preencha todos os campos do formulário',
	'dashboards.sample.userOf': 'Usuário de',
	'dashboards.sample.userFor': 'Usuário para',
	'dashboards.sample.process': 'Processos',
	'dashboards.sample.processOf': 'Processo de',
	'dashboards.sample.processFor': 'Processo para',
	'dashboards.sample.searchByExamNumber': 'Pesquisar por número de exame',
	'dashboards.sample.clearSelected': 'Limpar selecionados',
	'dashboards.sample.users': 'Usuários',
	'dashboards.sample.fillTheCollection':
		'Preencha todas as informações para o recolhimento',
	'dashboards.sample.thisItemHasAdded': 'Este item já foi adicionado',
	'dashboards.sample.bladesCreatedSuccessfully': 'Lâminas criadas com sucesso!',
	'dashboards.sample.itemsMovedSuccessfully': 'Itens movidos com sucesso',
	'dashboards.sample.changeTheType': 'Deseja realmente mudar o tipo?',
	'dashboards.sample.tableDataErased': 'Os dados da tabela serão apagados',
	'dashboards.sample.technicianName': 'Nome do Técnico',

	/* 04.Gráficos */

	'dashboards.graphics.graphics': 'Gráficos',
	'dashboards.graphics.reportsDelivered': 'LAUDOS ENTREGUES POR PERÍODO',
	'dashboards.graphics.historyNonCompliance':
		'HISTÓRICO DE NÃO CONFORMIDADE POR PERÍODO',
	'dashboards.graphics.averageTime': 'TEMPO MÉDIO DAS ETAPAS',
	'dashboards.graphics.materialProductivity': 'PRODUTIVIDADE MATERIAL',
	'dashboards.graphics.macroscopicMap': 'PRODUTIVIDADE MAPA MACROSCÓPICO',
	'dashboards.graphics.selectScenery': 'Selecione um cenário',
	'dashboards.graphics.initial': 'Inicial',
	'dashboards.graphics.last': 'Final',
	'dashboards.graphics.generate': 'Gerar',
	'dashboards.graphics.reportsDeliveredMonth':
		'Total de laudos entregues por mês',
	'dashboards.graphics.noDataPeriod': 'Nenhum dado no período informado',
	'dashboards.graphics.totalOfBottles': 'Total de Frascos gerados no período',
	'dashboards.graphics.totalOfCassetes': 'Total de Cassetes gerados no período',
	'dashboards.graphics.freezingBlade': 'LAMINA_CONGELACAO',

	/* 05.Histologia */

	'dashboards.histology.histologyInclusion': 'Histologia Inclusão',
	'dashboards.histology.histologyBlades': 'Histologia Lâminas',
	'dashboards.histology.delegationOfBlades': 'Delegação de Lâminas',
	'dashboards.histology.editBlock': 'Editar bloco',
	'dashboards.histology.delegation': 'Delegação',
	'dashboards.histology.consultCytotechnicians': 'Consultar Citotécnicos',
	'dashboards.histology.responsibleCytotechnician': 'Citotécnico responsável',
	'dashboards.histology.detailsCytotechnicianDelegation':
		'Detalhes da delegação do Citotécnico',
	'dashboards.histology.exam': 'Exame',
	'dashboards.histology.report': 'Laudo',
	'dashboards.histology.noBladeFound': 'Nenhuma lâmina encontrada',
	'dashboards.histology.errorWritingBlades': 'Erro ao gravar lâminas',
	'dashboards.histology.successfullyDelegatedBlade':
		'Lâmina delegada com sucesso',
	'dashboards.histology.bladeSuccessfullyRequested':
		'Lâmina solicitada com sucesso',
	'dashboards.histology.successfullyCanceledDelegations':
		'Delegações canceladas com sucesso',
	'dashboards.histology.cutout': 'Recorte',
	'dashboards.histology.biopsy': 'Biópsia',
	'dashboards.histology.autopsy': 'Autópsia',
	'dashboards.histology.piece': 'Peça',
	'dashboards.histology.withAntibodies': 'Com Anticorpos',
	'dashboards.histology.sentries': 'Sentinelas',
	'dashboards.histology.selectBlocks': 'Selecionar blocos',
	'dashboards.histology.clean': 'Limpar',
	'dashboards.histology.cancelBlock': 'Cancelar bloco',
	'dashboards.histology.cancelBlade': 'Cancelar lâmina',
	'dashboards.histology.cancelThisBlock':
		'Tem certeza que deseja cancelar este bloco?',
	'dashboards.histology.cancelThisBlade':
		'Tem certeza que deseja cancelar esta lâmina?',
	'dashboards.histology.nonconformitySuccessfullyAdded':
		'Não conformidade adicionada com sucesso',
	'dashboards.histology.displayUpdatedSuccessfully':
		'Exibição atualizada com sucesso',
	'dashboards.histology.resolutionSavedSuccessfully':
		'Resolução salva com sucesso',
	'dashboards.histology.resolveIn': 'Resolvida em',
	'dashboards.histology.includedIn': 'Incluída em',
	'dashboards.histology.inStep': 'na etapa',
	'dashboards.histology.successfullyMoved': 'Movido com sucesso',
	'dashboards.histology.puncture': 'Punção',
	'dashboards.histology.autoInput': 'Entrada automática',
	'dashboards.histology.createBlades': 'Criar lâminas',
	'dashboards.histology.unableMoveSelectedMaterials':
		'Não foi possível mover os materiais selecionados',

	/* 06.Citologia */

	'dashboards.cytology.geral': 'Citologia Geral',
	'dashboards.cytology.technical': 'Todos os Técnicos',
	'dashboards.cytology.danglingBlades': 'Lâminas pendentes',
	'dashboards.cytology.bladesInProgress': 'Lâminas em andamento',
	'dashboards.cytology.bladesReady': 'Lâminas prontas',
	'dashboards.cytology.addBlades': 'Adicionando lâminas',
	'dashboards.cytology.editBlades': 'Editar lâmina',
	'dashboards.cytology.numberExam': 'Nº do exame',
	'dashboards.cytology.blockCytology': 'Bloco de citologia:',
	'dashboards.cytology.selectBlock':
		'Selecionar um bloco de citologia (opcional)',
	'dashboards.cytology.noBlock': 'Nenhum bloco de citologia para este exame',
	'dashboards.cytology.technician': 'Técnico:',
	'dashboards.cytology.pathologist': 'Patologista:',
	'dashboards.cytology.cytology': 'Citologia',
	'dashboards.cytology.addCassetes': 'Adicionando cassetes de citologia',
	'dashboards.cytology.bottles': 'Frascos:',
	'dashboards.cytology.selectBottle': 'Selecionar frasco',
	'dashboards.cytology.numberOfCassetes': 'Número de cassetes:',
	'dashboards.cytology.fragmentsCassette': 'Fragmentos por cassete:',
	'dashboards.cytology.multipleFragments': 'Vários fragmentos?',
	'dashboards.cytology.newCuts': 'Novos cortes',
	'dashboards.cytology.colors': 'Colorações:',
	'dashboards.cytology.selectAntigens': 'Selecione os antígenos',
	'dashboards.cytology.selectMaterial': 'Selecionar material',
	'dashboards.cytology.type': 'Tipo:',
	'dashboards.cytology.melanomaSentinel': 'Sentinela melanoma',
	'dashboards.cytology.mamaSentry': 'Sentinela mama',
	'dashboards.cytology.macroscopyTechnician': 'Técnico macroscopia:',
	'dashboards.cytology.doctorMacroscopy': 'Médico macroscopia:',
	'dashboards.cytology.selectDoctor': 'Selecionar médico',
	'dashboards.cytology.addCassete': 'Adicionar cassete',
	'dashboards.cytology.cancel': 'CANCELADO',
	'dashboards.cytology.allFields': 'Preencha todos os campos',
	'dashboards.cytology.successBlock':
		'Bloco criado com sucesso. Uma lâmina foi gerada para este bloco',
	'dashboards.cytology.selectTechnician': 'Selecionar técnico responsável',
	'dashboards.cytology.organizeLots': 'Organizar Lotes',
	'dashboards.cytology.organizeLot': 'Organizar Lote',
	'dashboards.cytology.identificationNumber': 'Numero da identificação',
	'dashboards.cytology.selectDestiny': 'Selecione o Destino',
	'dashboards.cytology.nameOfExam': 'Nome do exame',
	'dashboards.cytology.nameOfPatient': 'Nome do Paciente',
	'dashboards.cytology.toAddBlades': 'Adicionar lâminas',
	'dashboards.cytology.batchLabels': 'Etiquetas em lote',
	'dashboards.cytology.sendBatch': 'Enviar em lote',
	'dashboards.cytology.noItemsSend': 'Nenhum item para enviar',
	'dashboards.cytology.printLabelsBatch': 'Imprimir etiquetas em lote',
	'dashboards.cytology.delegationBlades': 'Delegação de lâminas',
	'dashboards.cytology.consultCytotechnicians': 'Consultar Citotécnicos',
	'dashboards.cytology.statusDelegation': 'Status da delegação do Citotécnico',
	'dashboards.cytology.delegationDate': 'Data delegação',
	'dashboards.cytology.delegationCytotechnician': 'Delegação para Citotécnico:',
	'dashboards.cytology.selectCytotechnician': 'Selecionar Citotécnico',
	'dashboards.cytology.search': 'Pesquisar',
	'dashboards.cytology.delegateBlades': 'Delegar lâminas',
	'dashboards.cytology.removeDelegation': 'Remover delegação',
	'dashboards.cytology.cytotechnician': 'Citotécnico',
	'dashboards.cytology.delegatedBlades': 'Lâminas delegadas',
	'dashboards.cytology.remainingBlades': 'Lâminas restantes',
	'dashboards.cytology.code': 'Código',
	'dashboards.cytology.poweredBlades': 'Lâmina movida com sucesso',
	'dashboards.cytology.bladesNotMoved': 'Não foi possível atualizar a lâmina',
	'dashboards.cytology.updateDate': 'Data de Atualização',
	'dashboards.cytology.deleteBlade': 'Apagar a lâmina ',
	'dashboards.cytology.certaintyDelete':
		'Tem certeza que deseja apagar esta lâmina?',
	'dashboards.cytology.nonconformityToBlock':
		'Inserir não conformidade ao bloco ',
	'dashboards.cytology.nonconformityToBlade':
		'Inserir não conformidade na lâmina ',
	'dashboards.cytology.nonconformityToReport':
		'Exibir não conformidade ao laudo',
	'dashboards.cytology.solve': 'Resolver',
	'dashboards.cytology.nonComplianceDisplayed':
		'Não conformidade exibida no texto final do laudo',
	'dashboards.cytology.listItems': 'Lista de itens da coluna ',
	'dashboards.cytology.toMove': 'para mover',
	'dashboards.cytology.origin': 'Origem:',
	'dashboards.cytology.destiny': ' Destino:',
	'dashboards.cytology.errorBlades': 'Erro ao mover as lâminas selecionadas',
	'dashboards.cytology.successBlades': 'Lâminas movidas com sucesso',
	'dashboards.cytology.selectNonConformity':
		'É necessário selecionar uma não conformidade',
	'dashboards.cytology.bladesCreated': 'Lâmina criada com sucesso',

	/* 07.Imunologia */

	'dashboards.immunology.blockedImpedingNonconformity':
		'Bloqueado por inconformidade impeditiva!',
	'dashboards.immunology.unexpectedErrorOccurred': 'Ocorreu um erro inesperado',
	'dashboards.immunology.immunologySlides': 'Imunologia lâminas',

	/* 08.Controle de Tarefas */

	'dashboards.taskControl.general': 'Controle de Tarefas',
	'dashboards.taskControl.type': 'Escolha um tipo',
	'dashboards.taskControl.initialFilter': 'Inicial',
	'dashboards.taskControl.finalFilter': 'Final',
	'dashboards.taskControl.blocks': 'Blocos',
	'dashboards.taskControl.immune': 'Imuno',
	'dashboards.taskControl.citologySlides': 'Lâminas Citologia',
	'dashboards.taskControl.histologySlides': 'Lâminas Histologia',
	'dashboards.taskControl.titleReportCitologySlides': 'LÂMINAS DE CITOLOGIA',
	'dashboards.taskControl.titleReportHistologySlides': 'LÂMINAS DE HISTOLOGIA',
	'dashboards.taskControl.exam': 'Exame',
	'dashboards.taskControl.block': 'Bloco',
	'dashboards.taskControl.fragments': 'N° de fragmentos',
	'dashboards.taskControl.macroscopist': 'Macroscopista',
	'dashboards.taskControl.typeCassette': 'Tipo de cassete',
	'dashboards.taskControl.material': 'Material',
	'dashboards.taskControl.coloring': 'Coloração',
	'dashboards.taskControl.urgency': 'Urgência',
	'dashboards.taskControl.nc': 'NC',
	'dashboards.taskControl.printOut': 'Imprimir',
	'dashboards.taskControl.dataSucessfully': 'Sucesso',
	'dashboards.taskControl.itemUrgenciaYes': 'Sim',
	'dashboards.taskControl.itemUrgenciaNo': 'Não',
	'dashboards.taskControl.itemNCYes': 'Sim',
	'dashboards.taskControl.itemNCNo': 'Não',
	'dashboards.taskControl.blade': 'Lâmina',
	'dashboards.taskControl.linkedExam': 'Exame Vinculado',
	'dashboards.taskControl.bladeType': 'Tipo de Lâmina',
	'dashboards.taskControl.pathologistDoctor': 'Patologista',
	'dashboards.taskControl.medicalRecord': 'Prontuário',
	'dashboards.taskControl.dateCompleted': 'Data finalizado',
	'dashboards.taskControl.antibody': 'Anticorpo',
	'dashboards.taskControl.clone': 'Clone',
	'dashboards.taskControl.species': 'Espécie',
	'dashboards.taskControl.status': 'Status',
	'dashboards.taskControl.noResult': 'Nenhum resultado encontrado',
	'dashboards.taskControl.receptacleControl': 'CONTROLE DE RECEPTÁCULO',
	'dashboards.taskControl.responsibleMacro': 'Responsável macro',
	'dashboards.taskControl.technicalManager': 'Responsável técnico',
	'dashboards.taskControl.patient': 'Paciente',
	'dashboards.taskControl.canceled': 'Cancelada',

	/* 09.Tarefas do Médico */
	'dashboards.doctorTasks.selectSearchType': 'Selecionar tipo de busca',
	'dashboards.doctorTasks.selectResponsibleReviewer': 'Selecionar revisor responsável',
	'dashboards.doctorTasks.examsToReview': 'Exames a revisar',
	'dashboards.doctorTasks.revisedExams': 'Exames revisados',
	'dashboards.doctorTasks.reportDetails': 'Detalhes do laudo',
	'dashboards.doctorTasks.releaseBatchReports': 'Liberar laudos em lote',
	'dashboards.doctorTasks.releaseBatch': 'Liberação em lote',
	'dashboards.doctorTasks.orderNumber': 'Nº do pedido',
	'dashboards.doctorTasks.examNumber': 'Nº do exame',
	'dashboards.doctorTasks.insert': 'Inserir',
	'dashboards.doctorTasks.orderAlreadyEntered': 'Pedido já foi inserido',
	'dashboards.doctorTasks.ordersReleasedSuccessfully': 'Pedidos liberados com sucesso',
	'dashboards.doctorTasks.partiallyReleasedOrders': 'Alguns pedidos não foram liberados. Estes se manterão no grid',
	'dashboards.doctorTasks.unreleasedOrders': 'Houve um problema. Os pedidos não foram liberados',
	'dashboards.doctorTasks.enterYourSSN': 'Informe o CPF',
	'dashboards.doctorTasks.enterYourPIN': 'Informe o PIN',

	/* 10.Descarte de Material */

	'dashboards.disposalMaterials.initialFilter': 'Inicial',
	'dashboards.disposalMaterials.finalFilter': 'Final',
	'dashboards.disposalMaterials.type.special': 'Especial',
	'dashboards.disposalMaterials.type.burial': 'Sepultamento',
	'dashboards.disposalMaterials.type.standard': 'Padrão',
	'dashboards.disposalMaterials.discardReports':
		'RELATÓRIO DE MATERIAIS PARA DESCARTE',
	'dashboards.disposalMaterials.discardedReports':
		'RELATÓRIO DE MATERIAIS DESCARTADOS',
	'dashboards.disposalMaterials.signatureCRM': 'Assinatura - CRM',
	'dashboards.disposalMaterials.general': 'Descarte de Materiais',
	'dashboards.disposalMaterials.discardedMaterials': 'Materiais Descartados',
	'dashboards.disposalMaterials.reports': 'Relatórios',
	'dashboards.disposalMaterials.chooseOne': 'Escolha um',
	'dashboards.disposalMaterials.disposalDate': 'Data do Descarte',
	'dashboards.disposalMaterials.lotDescription': 'Descrição do Lote',
	'dashboards.disposalMaterials.items': 'Itens',
	'dashboards.disposalMaterials.examNumber': 'Número do Exame',
	'dashboards.disposalMaterials.totalWeight': 'Peso Total',
	'dashboards.disposalMaterials.user': 'Usuário',
	'dashboards.disposalMaterials.reportType': 'Tipo de relatório',
	'dashboards.disposalMaterials.standardDiscard': 'Descarte padrão',
	'dashboards.disposalMaterials.specialDisposal': 'Descarte especial',
	'dashboards.disposalMaterials.burialDisposal': 'Descarte de sepultamento',
	'dashboards.disposalMaterials.burialReport': 'Laudo para sepultamento',
	'dashboards.disposalMaterials.requestDate': 'Data do Pedido',
	'dashboards.disposalMaterials.discardDate': 'Data do Descarte',
	'dashboards.disposalMaterials.dueDate': 'Data do Vencimento',
	'dashboards.disposalMaterials.dateSolicitation': 'Data da Solicitação',
	'dashboards.disposalMaterials.materialDescription': 'Descrição do Material',
	'dashboards.disposalMaterials.daysExpire': 'Dias a Vencer',
	'dashboards.disposalMaterials.bottleIdentification':
		'Identificação do Frasco',
	'dashboards.disposalMaterials.examNumber': 'Número do Exame',
	'dashboards.disposalMaterials.requestNumber': 'Número do Pedido',
	'dashboards.disposalMaterials.patient': 'Paciente',
	'dashboards.disposalMaterials.toDiscard': 'Descartar',
	'dashboards.disposalMaterials.discardAll': 'Descartar todos',
	'dashboards.disposalMaterials.description': 'Descrição',
	'dashboards.disposalMaterials.restore': 'Restaurar',
	'dashboards.disposalMaterials.restoreAll': 'Restaurar todos',
	'dashboards.disposalMaterials.printOut': 'Imprimir',
	'dashboards.disposalMaterials.filters': 'Filtros',
	'dashboards.disposalMaterials.burial': 'Sepultamento',
	'dashboards.disposalMaterials.noResult': 'Nenhum resultado encontrado',
	'dashboards.disposalMaterials.dataSucessfully': 'Sucesso',
	'dashboards.disposalMaterials.table.exam': 'Exame',
	'dashboards.disposalMaterials.table.request': 'Pedido',
	'dashboards.disposalMaterials.table.dayExpire': 'Dias a Vencer',
	'dashboards.disposalMaterials.table.patient': 'Paciente (Registro Civil)',
	'dashboards.disposalMaterials.table.socialName': 'Nome Social',
	'dashboards.disposalMaterials.table.weight': 'Peso (g)',
	'dashboards.disposalMaterials.table.material': 'Material',
	'dashboards.disposalMaterials.table.bottle': 'Frasco',
	'dashboards.disposalMaterials.table.nobottle':
		'Este laudo não possui nenhum frasco!',
	'dashboards.disposalMaterials.table.requestDate': 'Data do Pedido',
	'dashboards.disposalMaterials.table.expirationDate': 'Data do Vencimento',
	'dashboards.disposalMaterials.table.deliveryDate': 'Data do recebimento',
	'dashboards.disposalMaterials.table.totalDiscard': 'Total de Descarte:',
	'dashboards.disposalMaterials.table.materialsTotalDiscard':
		'Total de Materiais Descartados',
	'dashboards.disposalMaterials.table.items': 'Itens',
	'dashboards.disposalMaterials.table.exams': 'Exames',
	'dashboards.disposalMaterials.table.user': 'Usuário',
	'dashboards.disposalMaterials.table.observationDiscard':
		'Observação do descarte',
	'dashboards.disposalMaterials.table.descriptionLot': 'Descrição do Lote',
	'dashboards.disposalMaterials.modal.disposalInformation':
		'Informações para o descarte',
	'dashboards.disposalMaterials.modal.weightG': 'Peso em (G):',
	'dashboards.disposalMaterials.modal.weightKG': 'Peso em (KG):',
	'dashboards.disposalMaterials.modal.observation': 'Observação:',
	'dashboards.disposalMaterials.modal.reasonDiscard': 'Motivo do descarte',
	'dashboards.disposalMaterials.modal.wantPrint': 'Deseja Imprimir',
	'dashboards.disposalMaterials.modal.cancel': 'Cancelar',
	'dashboards.disposalMaterials.modal.confirm': 'Confirmar',

	/* 11.Arquivamento de Material */

	'general.materialArchiving.user': 'Usuário',
	'general.materialArchiving.error': 'Erro',
	'general.materialArchiving.save': 'Salvar',
	'general.materialArchiving.description': 'Descrição',
	'general.materialArchiving.toFile': 'Arquivar',
	'general.materialArchiving.close': 'Fechar',
	'general.materialArchiving.toMove': 'Mover',
	'general.materialArchiving.confirm': 'Confirmar',
	'general.materialArchiving.initial': 'Inicial',
	'general.materialArchiving.final': 'Final',
	'general.materialArchiving.identification': 'Identificação',
	'general.materialArchiving.noResultsFound': 'Nenhum resultado encontrado',
	'general.materialArchiving.material': 'Material',
	'general.materialArchiving.type': 'Tipo',
	'general.materialArchiving.selectType': 'Selecione o tipo',
	'general.materialArchiving.selectDestination': 'Selecione o destino',
	'general.materialArchiving.selectTheApplicant': 'Selecione o solicitante',
	'general.materialArchiving.patient': 'Paciente',
	'general.materialArchiving.socialName': 'Nome Social',
	'general.materialArchiving.technician': 'Técnico',
	'general.materialArchiving.requestDate': 'Data do pedido',
	'general.materialArchiving.expectedReturnDate': 'Data Prevista da Devolução',
	'general.materialArchiving.expectedDate': 'Data prevista',
	'general.materialArchiving.filingDate': 'Data de arquivamento',
	'general.materialArchiving.completionDate': 'Data de finalização',
	'general.materialArchiving.dateOfChange': 'Data de alteração',
	'general.materialArchiving.completed': 'Concluídos',
	'general.materialArchiving.cancel': 'Cancelar',
	'general.materialArchiving.details': 'Detalhes',
	'general.materialArchiving.request': 'Requisição',
	'general.materialArchiving.audit': 'Auditoria',
	'general.materialArchiving.requested': 'Solicitados',
	'general.materialArchiving.addRequisition': 'Adicionar requisição',
	'general.materialArchiving.archived': 'Arquivado',
	'general.materialArchiving.archiveds': 'Arquivados',
	'general.materialArchiving.requester': 'Solicitante',
	'general.materialArchiving.theBlock': 'o bloco',
	'general.materialArchiving.block': 'Bloco',
	'general.materialArchiving.blocks': 'Blocos',
	'general.materialArchiving.blocksAndBlades': 'Blocos e Lâminas',
	'general.materialArchiving.blockMoved': 'Bloco movido',
	'general.materialArchiving.movedBlade': 'Lâmina Movida',
	'general.materialArchiving.successfully': 'com sucesso',
	'general.materialArchiving.success': 'Sucesso',
	'general.materialArchiving.theBlade': 'a lâmina',
	'general.materialArchiving.blade': 'Lâmina',
	'general.materialArchiving.blades': 'Lâminas',
	'general.materialArchiving.anErrorOccurred': 'Ocorreu um erro ao mover',
	'general.materialArchiving.successfullyRemoved':
		'Removido do arquivamento com sucesso',
	'general.materialArchiving.materialType': 'Tipo do Material',
	'general.materialArchiving.examNumber': 'Número do Exame',
	'general.materialArchiving.exam': 'Exame',
	'general.materialArchiving.confirmationManualArchiving':
		'Confirmação para arquivamento manual',
	'general.materialArchiving.reason': 'Motivo',
	'general.materialArchiving.informTheReason': 'Informe o motivo',
	'general.materialArchiving.location': 'Localização física do bloco e/ou lâmina',
	'general.materialArchiving.materialLocation': 'Localização do material',
	'general.materialArchiving.previousLocations': 'Localizações anteriores',
	'general.materialArchiving.registerNewLocation': 'Cadastrar nova localização',
	'general.materialArchiving.manualArchiving': 'Arquivamento manual',
	'general.materialArchiving.archiving': 'Arquivamento',
	'general.materialArchiving.archivingDoneSuccessfully':
		'Arquivamento feito com sucesso',
	'general.materialArchiving.medicalRecord': 'Prontuário',
	'general.materialArchiving.destiny': 'Destino',
	'general.materialArchiving.report': 'Laudo',
	'general.materialArchiving.operation': 'Operação',
	'general.materialArchiving.maximumCharacters':
		'Máximo de caracteres atingido',
	'general.materialArchiving.remain': 'Restam',
	'general.materialArchiving.characters': 'caracteres',
	'general.materialArchiving.informTheLocationStored':
		'Informe a localização onde o material será armazenado.',
	'general.materialArchiving.removeArchive':
		'Tem certeza que deseja remover do aquivamento o ',
	'general.materialArchiving.remove': 'Remover',
	'general.materialArchiving.reportType': 'Tipo de relatório',
	'general.materialArchiving.chooseOne': 'Escolha um ',
	'general.materialArchiving.exportCSV': 'Exportar CSV',
	'general.materialArchiving.printOut': 'Imprimir',
	'general.materialArchiving.uninformed': 'Não informado',
	'general.materialArchiving.AUDITREPORTOFFILINGANDMATERIALREQUEST':
		'RELATÓRIO DE AUDITORIA DOS ARQUIVAMENTO E REQUISIÇÃO DE MATERIAL',
	'general.materialArchiving.deliveredToThePatient': 'Entregue ao paciente',
	'general.materialArchiving.requestCancellationCompleted!':
		'Cancelamento de requisição concluído com sucesso!',
	'general.materialArchiving.shouldBeForwardedToHistologySlides':
		'Deverá ser encaminhado para Histologia Lâminas',
	'general.materialArchiving.shouldBeForwardedImmunologySlides':
		'Deverá ser encaminhado para Imunologia Lâminas',
	'general.materialArchiving.materialRequisitionCancellation':
		'Cancelamento de Requisição de Material',
	'general.materialArchiving.noBlocksOrSlidesAvailable':
		'Este exame não possui blocos ou lâminas disponiveis',
	'general.materialArchiving.requestMadeSuccessfully':
		'Requisição realizada com sucesso',
	'general.materialArchiving.confirmationForMaterialRequisition':
		'Confirmação para a requisição de material',
	'general.materialArchiving.materialRequisitionRequestInformation':
		'Informação da solicitação de requisição de materiais',
	'general.materialArchiving.ArchivingReason': 'Localização',

	/* 12.Relatórios */

	'dashboards.reports.criticalReport': 'Laudo crítico',
	'dashboards.reports.disposalMaterials': 'Descarte de Materiais',
	'dashboards.reports.archiving': 'Arquivamento',
	'dashboards.reports.taskControl': 'Controle de tarefas',
	'dashboards.reports.requestsPanel': 'Painel de Solicitações',
	'dashboards.reports.reportsCID': 'Laudos S/ CID',
	'dashboards.reports.invoicing': 'Faturamento',
	'dashboards.reports.all': 'Todos',
	'dashboards.reports.doctorResponsible': 'Médico responsável',
	'dashboards.reports.searchType': 'Tipo de busca',
	'dashboards.reports.selectOption': 'Selecione uma opção',
	'dashboards.reports.initial': 'Inicial',
	'dashboards.reports.last': 'Final',
	'dashboards.reports.printOut': 'Imprimir',
	'dashboards.reports.deliveryDate': 'Data de entrega',
	'dashboards.reports.requestDate': 'Data de solicitação',
	'dashboards.reports.examNumber': 'Número do exame',
	'dashboards.reports.noResults': 'Sem resultados',
	'dashboards.reports.requestNumber': 'Número do pedido',
	'dashboards.reports.patientName': 'Nome do paciente',
	'dashboards.reports.observationReport': 'Observação do laudo',
	'dashboards.reports.examType': 'Tipo de exame',
	'dashboards.reports.urgent': 'Urgente',
	'dashboards.reports.totalCriticalExams': 'Total de exames críticos:',
	'dashboards.reports.totalReports': 'Total de Laudos:',
	'dashboards.reports.noResultsFound': 'Nenhum resultado encontrado',
	'dashboards.reports.exam': 'Exame',
	'dashboards.reports.status': 'Status',
	'dashboards.reports.patientCivilRegistry': 'Paciente (Registro Civil)',
	'dashboards.reports.socialName': 'Nome Social',
	'dashboards.reports.doctor': 'Médico',
	'dashboards.reports.type': 'Tipo',
	'dashboards.reports.dateRequest': 'Data do pedido',
	'dashboards.reports.medicalRecord': 'Prontuário',
	'dashboards.reports.notifications': 'Notificações',
	'dashboards.reports.yes': 'Sim',
	'dashboards.reports.no': 'Não',
	'dashboards.reports.bottle': 'Frasco',
	'dashboards.reports.material': 'Material',
	'dashboards.reports.deliverydates': 'Data do recebimento',
	'dashboards.reports.deliverydates': 'Data do recebimento',
	'dashboards.reports.discardRequestingPhysician':
		'Médico solicitante do Descarte',
	'dashboards.reports.discardDate': 'Data do descarte',
	'dashboards.reports.materialSpecial':
		'RELATÓRIO DE MATERIAIS PARA DESCARTE ESPECIAL',
	'dashboards.reports.specialRecord': 'REGISTRO DE DESCARTE ESPECIAL',
	'dashboards.reports.subscriptionCRM': 'Assinatura - CRM',
	'dashboards.reports.burialRequestingPhysician':
		'Médico solicitante do Sepultamento',
	'dashboards.reports.reportBurial':
		'RELATÓRIO DE MATERIAIS PARA DESCARTE DE PEÇAS PARA SEPULTAMENTO',
	'dashboards.reports.registrationBurial':
		'REGISTRO DE MATERIAIS PARA SEPULTAMENTO',
	'dashboards.reports.doctorMacro': 'Médico resp. Macro',
	'dashboards.reports.materialArchiving': 'Arquivamento de Material',
	'dashboards.reports.materialRequest': 'Requisição de material',
	'dashboards.reports.dateArchiving': 'Data do Arquivamento',
	'dashboards.reports.observation': 'Observação',
	'dashboards.reports.reportArchiving': 'RELATÓRIO DE ARQUIVAMENTO DE MATERIAL',
	'dashboards.reports.requester': 'Requisitante',
	'dashboards.reports.reportMaterialRequest':
		'RELATÓRIO DE REQUISIÇÃO DE MATERIAL',
	'dashboards.reports.returnDate': 'Data Prevista para a devolução',
	'dashboards.reports.lastDate': 'Data final',
	'dashboards.reports.examCID': 'Total de exames sem CID:',
	'dashboards.reports.performingPhysician': 'Médico Executante',
	'dashboards.reports.totalExam': 'Total de exames:',
	'dashboards.reports.released': 'Liberado',
	'dashboards.reports.partiallyReleased': 'Parcialmente liberado',
	'dashboards.reports.inProgress': 'Em andamento',
	'dashboards.reports.ready': 'Pronta',
	'dashboards.reports.pending': 'Pendente',
	'dashboards.reports.finished': 'Finalizado',
	'dashboards.reports.criticalReportContact':
		'Registro de contato de laudo crítico',
	'dashboards.reports.notifiedRequestingPhysician':
		'Médico solicitante notificado:',
	'dashboards.reports.enterDoctor': 'Digite o médico',
	'dashboards.reports.phone': 'Telefone',
	'dashboards.reports.comment': 'Comentário:',
	'dashboards.reports.notificationSuccess': 'Notificação criada com sucesso',
	'dashboards.reports.criticalReportNotifications':
		'NOTIFICAÇÕES DO LAUDO CRÍTICO',
	'dashboards.reports.externalExamNumber': 'Número exame externo',
	'dashboards.reports.materialDeliveryDate': 'Data de entrega do material',
	'dashboards.reports.expectedDeliveryDate': 'Data de entrega prevista',
	'dashboards.reports.notification': 'Notificação',
	'dashboards.reports.materialDelivered': 'Material entregue',
	'dashboards.reports.estimatedDelivery': 'Entrega prevista',
	'dashboards.reports.delivery': 'Entrega',
	'dashboards.reports.criticalReports': 'LAUDOS CRÍTICOS',
	'dashboards.reports.examNoNotification':
		'Este exame não possui nenhuma notificação',
	'dashboards.reports.examNoCassete': 'Este exame não possui nenhum cassete',
	'dashboards.reports.noItemsFound': 'Nenhum item encontrado',
	'dashboards.reports.examNotFound': 'O exame não foi encontrado',
	'dashboards.reports.informIndication': 'Deseja informar a indicação?',
	'dashboards.reports.indication': 'Indicação:',
	'dashboards.reports.burialReport': 'LAUDO PARA SEPULTAMENTO',
	'dashboards.reports.typeCassete': 'Tipo cassete',
	'dashboards.reports.fragments': 'Fragmentos',
	'dashboards.reports.medicalRecordRGHC': 'Prontuário / RGHC',
	'dashboards.reports.yearsOld': 'Idade',
	'dashboards.reports.antibodies': 'Anticorpos',
	'dashboards.reports.inconclusive': 'Inconclusivo',
	'dashboards.reports.negative': 'Negativo',
	'dashboards.reports.positive': 'Positivo',
	'dashboards.reports.antigenRequisitionReport':
		'RELATÓRIO DE REQUISIÇÃO DE ANTÍGENOS',
	'dashboards.reports.printPreview': 'Visualização para impressão',

	/* 13.Painel de Solicitações */

	'general.requestsPanel.title': 'Painel de Solicitações',
	'general.requestsPanel.status': 'Status',
	'general.requestsPanel.requestChangedSuccessfully':
		'Solicitação alterada com sucesso',
	'general.requestsPanel.all': 'Todos',
	'general.requestsPanel.error': 'Erro',
	'general.requestsPanel.type': 'Tipo',
	'general.requestsPanel.initial': 'Inicial',
	'general.requestsPanel.final': 'Final',
	'general.requestsPanel.selectType': 'Selecione o tipo',
	'general.requestsPanel.selectStatus': 'Selecione o status',
	'general.requestsPanel.selectAll': 'Selecionar tudo',
	'general.requestsPanel.close': 'Fechar',
	'general.requestsPanel.save': 'Salvar',
	'general.requestsPanel.date': 'Data',
	'general.requestsPanel.success': 'Sucesso',
	'general.requestsPanel.request': 'Solicitar',
	'general.requestsPanel.requested': 'Solicitado',
	'general.requestsPanel.requestDate': 'Data da solicitação',
	'general.requestsPanel.registrationDate': 'Data de cadastro',
	'general.requestsPanel.dateOfChange': 'Data de alteração',
	'general.requestsPanel.requestDetails': 'Detalhes da solicitação',
	'general.requestsPanel.requestingUser': 'Usuário solicitante',
	'general.requestsPanel.executingUser': 'Usuário Executante',
	'general.requestsPanel.comment': 'Comentário',
	'general.requestsPanel.registrationOfRequests': 'Registro de solicitações',
	'general.requestsPanel.requester': 'Solicitante',
	'general.requestsPanel.performer': 'Executante',
	'general.requestsPanel.identifier': 'Identificador',
	'general.requestsPanel.searchType': 'Tipo de busca',
	'general.requestsPanel.selectAnOption': 'Selecione uma opção',
	'general.requestsPanel.doctorResponsible': 'Médico responsável',
	'general.requestsPanel.initial': 'Inicial',
	'general.requestsPanel.final': 'Final',
	'general.requestsPanel.patient': 'Paciente',
	'general.requestsPanel.medicalRecord': 'Prontuário',
	'general.requestsPanel.print': 'Imprimir',
	'general.requestsPanel.bottle': 'Frasco',
	'general.requestsPanel.block': 'Bloco',
	'general.requestsPanel.selectBlock': 'Selecione o bloco',
	'general.requestsPanel.exam': 'Exame',
	'general.requestsPanel.totalExams': 'Total de Exames',
	'general.requestsPanel.examNumber': 'Número do Exame',
	'general.requestsPanel.totalRequests': 'Total de solicitações',
	'general.requestsPanel.noResultsFound': 'Nenhum resultado encontrado',
	'general.requestsPanel.colorations': 'Colorações',
	'general.requestsPanel.selectColors': 'Selecione as colorações',
	'general.requestsPanel.errorListingItems': 'Erro ao listar itens',
	'general.requestsPanel.necessaryInformType': 'É necessário informar o tipo',
	'general.requestsPanel.necessaryInformBottle':
		'É necessário informar o frasco',
	'general.requestsPanel.necessaryInformBlock': 'É necessário informar o bloco',
	'general.requestsPanel.requestCreatedSuccessfully':
		'Solicitação criada com sucesso',
	'general.requestsPanel.requestsMade': 'SOLICITAÇÕES REALIZADAS',
	'general.requestsPanel.signature': 'Assinatura',
	'general.requestsPanel.newCut': 'Novo corte',
	'general.requestsPanel.deepening': 'Aprofundamento',
	'general.requestsPanel.inProgress': 'Em andamento',
	'general.requestsPanel.done': 'Feito',

	/* 14.Rastreamento de Amostra - NOVO */

	/* 15.Pagina de Erros */

	'error.title': 'Houve um erro na Página',
	'error.code': 'O código do erro encontrado foi',
	'error.gobackhome': 'Voltar para a página Inicial',
	'error.notfoundpage': 'Página não Encontrada',
	'error.notfoundpagedesc': 'Não foi possível encontrar a página solicitada',

	/* 16.Mensagens */

	'message.noExamFound': 'Nenhum exame encontrado',
	'message.examFound': 'Exame(s) encontrado(s)',
	'message.loading': 'Carregando...',
	'message.maxlength': 'Máximo de carácteres atingido',
	'message.remaining.more': 'Restam {char} caracteres',
	'message.remaining.only': 'Resta {char} caracter',
	'message.errorEditor':
		'Erro ao carregar o editor. Recarregue a página para tentar novamente',
	'message.welcome': 'Seja bem-vindo(a)',
	'message.expired': 'Sessão expirada',
	'message.userNotCheck': 'Usuário não confere',
	'message.notPermission': 'Permissão não encontrada',
	'message.permissionNot': 'Permissão não confere',
	'messages.noChargeReport': 'Não foi possivel carregar o Laudo!',
	'message.expired.renewSession' : 'Você será deslogado em <b></b> segundos <div class="mt-4"></div> <button id="increase" class="btn btn-primary"> Continuar Sessão </button><br/><br/>',

	/* 17.Period */
	'period.name': 'Período',
	'period.order.request': 'Período do Pedido',
	'period.delegation': 'Período da delegação',
	'period.all': 'Todos',
	'period.today': 'Hoje',
	'period.yesterday': 'Ontem',
	'period.daybeforeyesterday': 'Antes de ontem',
	'period.has1week': 'Há 1 Semana',
	'period.has15days': 'Há 15 Dias',
	'period.has1month': 'Há 1 Mês',
	'period.has2months': 'Há 2 Meses',
	'period.has3months': 'Há 3 Meses',
	'period.has6months': 'Há 6 Meses',
	'period.has1year': 'Há 1 Ano',
	'period.other': 'Outro',
	'period.datestart': 'Data Inicial',
	'period.dateend': 'Data Final',

	/* 18.Checklist */
	'checklist.resp': 'Resposta',
	'checklist.modalTitle': 'Checklist de recebimento de amostra',

	/* .Encaminhamento */

	'dashboards.referral.referral': 'Encaminhamento para 2° opinião',
	'dashboards.referral.doctorAssigned': 'Médico designado para 2° opinião',

	/* Entrega de resultados */
	'dashboard.resultsScreen.modal.deliveryofexams': 'Entrega de exames',
	'dashboard.resultsScreen.modal.carryoutdelivery': 'Realizar Entrega',
	'dashboard.resultsScreen.modal.history': 'Histórico',
	'dashboard.resultsScreen.modal.deliveredto': 'Entregue a:',
	'dashboard.resultsScreen.modal.cpf': ' CPF:',
	'dashboard.resultsScreen.modal.notes': 'Anotações',
	'dashboard.resultsScreen.modal.internalnotes': 'Anotações Internas',
	'dashboard.resultsScreen.modal.noteswillnotbeincludedinthedeliveryprotocol':
		' * As anotações não sairão no protocolo de entrega',
	'dashboard.resultsScreen.modal.externaldocumentreturnedpatient':
		'Documento(s) externo(s) para devolução ao paciente:',
	'dashboard.resultsScreen.modal.examresult': 'Resultado Exame',
	'dashboard.resultsScreen.modal.deliveryprotocol': 'Protocolo de entrega',
	'dashboard.resultsScreen.modal.delivermaterial': 'Entregar Material',
	'dashboard.resultsScreen.modal.deliverycanceled': 'Entrega Cancelada',
	'dashboard.resultsScreen.modal.deliveredby': 'Entregue por',
	'dashboard.resultsScreen.modal.canceled': 'Cancelar',
	'dashboard.resultsScreen.modal.deliver': 'Entregar',
	'dashboard.resultsScreen.modal.confirm': 'Confirmar',
	'dashboard.resultsScreen.modal.sheets': 'Laminas:',
	'dashboard.resultsScreen.modal.block': 'Blocos:',
	'dashboard.resultsScreen.modal.selectdelivereditems':
		'Selecione os itens entregues',
	'dashboard.resultsScreen.modal.deliveredin': '; entregue em',
	'dashboard.resultsScreen.modal.description': 'Descrição: ',
	'dashboard.resultsScreen.modal.type': 'Tipo: ',
	'dashboard.resultsScreen.modal.reportViewedBy': 'Laudo visualizado/impresso por ',
	'dashboard.resultsScreen.modal.originPortal': 'via Portal de Exames',

	/* Modal óbito */
	'data.obito':'Dados do óbito',
	'modalobito.title':'Informações do óbito',
	'dateandhour.obito':'Data e hora do óbito:',
	'observations.obito':'Observações:',
	'messages.obito.updateSucess': 'Informações atualizadas com sucesso!',
	'messages.obito.updateError': 'Houve um erro ao atualizar as informações!',
	'messages.obito.insertSucess': 'Informações inseridas com sucesso!',
	'messages.obito.insertError': 'Houve um erro ao inserir as informações!',
	'messages.obito.removeSucess': 'Informações removidas com sucesso!',
	'messages.obito.removeError': 'Houve um erro ao remover as informações!',

	/* .Siscolo */
	'dashboard.siscolo.modal.title': 'Siscolo',
	'dashboard.siscolo.modal.dontknow': 'Não sabe ',

	/* Agrupar exames */
	'dashboard.groupExams.modal.title': 'Agrupar exames do pedido no recebimento do material',
	'dashboard.groupExams.modal': 'Agrupar exames',
};



// WEBPACK FOOTER //
// ./src/lang/locales/pt_BR.js